export default function accordionBtns() {
    let accBtns = document.querySelectorAll('.js-accordion-btn');

    accBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            let accList = btn.nextElementSibling;
            
            if (!btn.classList.contains('active')) {
                btn.classList.add('active');
                if(accList.nodeName !== 'DIV') {
                    accList.style.maxHeight = accList.scrollHeight + 'px';
                }
            } else {
                btn.classList.remove('active');
                if(accList.nodeName !== 'DIV') {
                    accList.style.maxHeight = '0px';
                }
            }
        })
    })

    let activeCatBtn = document.querySelectorAll('aside .active');

    if (activeCatBtn) {
        activeCatBtn.forEach(activeButton => {
            let activeList = activeButton.nextElementSibling
            if(activeList.nodeName !== 'DIV') {
                activeList.style.maxHeight = activeList.scrollHeight + 'px';
            }
        });
    }
}